module.exports = __webpack_public_path__ + "static/media/high-gpa-sm.dd63951c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/plants/high-gpa-sm.jpg
// module id = 166
// module chunks = 12